<template>
  <div class="container-fluid">
    <div  class="card border-primary shadow-lg">
      <div class="card-header text-white bg-primary mb-3">
        <label>{{ $t('menu.client.title') }}</label>
      </div>

      <div class="flex-grow-1 d-flex justify-content-center mx-4">
        <div class="col-12 col-lg-8 col-xl-8 col-xxl-6 col-sm-12">
            <text-field v-model="params.search" :placeholder="$t('object.monitoring.search')" clearable />
        </div>
      </div>

      <div class="card-body">
        <div class="accordion" id="accordionPanelsStayOpenExample">
          <template v-for="(row, index) in list" :key="row.clientId">
            <div class="accordion-item">
              <h2 class="accordion-header" :id="'heading_'+row.clientId">
                <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    :data-bs-target="'#collapse_'+row.clientId"
                    :aria-controls="'collapse_'+row.clientId"
                    @click="toggle(row.clientId)"
                >
                  {{ row.name }}
                </button>
              </h2>

              <div
                  :id="'collapse_'+row.clientId"
                  class="accordion-collapse collapse"
                  :aria-labelledby="'heading_'+row.clientId"
              >
                <div class="accordion-body" v-if="expanded[row.clientId]">
                  <Contacts :companyId="row.clientId" />
                </div>
              </div>
            </div>
          </template>
        </div>

        <Pagination
            :current-page="params.page"
            :total-pages="totalPages"
            :visible-pages="visiblePages"
            @change-page="changePage"
        />
      </div>
    </div>
  </div>
</template>

<script src="./Company.js"></script>
